import { ReportEquipmentParams } from "@/types/reportEquipment";

export class ReportEquipment {
  id: string;
  reportId: string;
  equipmentId: string;
  equipmentName: string;
  equipmentDescription: string;
  instrumentId: string;
  instrumentName: string;
  instrumentSerialNumber: string;
  instrumentManufacturer: string;
  instrumentModel: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;

  constructor(params: ReportEquipmentParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.reportId = params.reportId;
    this.equipmentId = params.equipmentId;
    this.equipmentName = params.equipmentName;
    this.equipmentDescription = params.equipmentDescription || '';
    this.instrumentId = params.instrumentId || '';
    this.instrumentName = params.instrumentName || '';
    this.instrumentSerialNumber = params.instrumentSerialNumber || '';
    this.instrumentManufacturer = params.instrumentManufacturer || '';
    this.instrumentModel = params.instrumentModel || '';
  }
}
